import ky from 'ky';
import { auth } from './firebase';

const apiRequest = ky.create({
  timeout: 30 * 1000,
  prefixUrl: '/api/v2/',
  hooks: {
    beforeRequest: [
      async (request) => {
        const user = auth.currentUser;
        if (user) {
          const idToken = await user.getIdToken(true);
          if (idToken) {
            request.headers.set('Authorization', `Bearer ${idToken}`);
          }
        }
      },
    ],
  },
});

export default apiRequest;
